import { render } from "./FrequencyDurationPanelDocked.vue?vue&type=template&id=0bed368b&scoped=true"
import script from "./FrequencyDurationPanelDocked.vue?vue&type=script&lang=js"
export * from "./FrequencyDurationPanelDocked.vue?vue&type=script&lang=js"

import "./FrequencyDurationPanelDocked.vue?vue&type=style&index=0&id=0bed368b&lang=scss&scoped=true"

import exportComponent from "../../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-0bed368b"]])

export default __exports__